import React from 'react';
import { ArrowUpRight, Calendar } from 'lucide-react';
import { blogPosts } from '../mock';
import { useLang } from '../i18n/LanguageContext';
import { useAssets } from '../assets/AssetsContext';

const BlogPosts = () => {
  const { t } = useLang();
  const { overrides, apiBase } = useAssets();
  return (
    <section className="py-24 md:py-32 bg-[#0B3D2E]">
      <div className="max-w-[1440px] mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <h2 className="font-serif-display text-4xl md:text-6xl leading-tight">
              <span className="text-[#ffffff]">{t('bp.title')} </span>
              <span className="peach-text italic">{t('bp.title.italic')}</span>
            </h2>
            <p className="text-[#ffffff]/70 mt-4 max-w-md">
              {t('bp.kicker')}
            </p>
          </div>
          <a
            href="#blog-all"
            className="btn-ghost-gold inline-flex items-center gap-2 px-7 py-3 rounded-full self-start md:self-auto"
          >
            {t('cta.visitBlog')}
            <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {blogPosts.map((post, i) => {
            const ov = overrides[`blog.${i}`];
            const src = ov ? `${apiBase}${ov.url}` : post.image;
            return (
            <article
              key={i}
              className="bg-[#124D3A] rounded-3xl overflow-hidden card-hover group border border-[#D4AF37]/10"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={src}
                  alt={post.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B3D2E]/60 to-transparent" />
              </div>
              <div className="p-7">
                <div className="flex items-center gap-2 text-xs text-[#D4AF37] mb-3">
                  <Calendar className="w-3.5 h-3.5" />
                  <span>{post.date}</span>
                </div>
                <h3 className="font-serif-display text-xl leading-snug text-[#ffffff] mb-3 group-hover:text-[#D4AF37] transition-colors">
                  {post.title}
                </h3>
                <p className="text-[#ffffff]/65 text-sm leading-relaxed mb-5 line-clamp-3">
                  {post.excerpt}
                </p>
                <a
                  href="#post"
                  className="inline-flex items-center gap-2 text-[#D4AF37] hover:text-[#F3DC8A] text-sm font-medium"
                >
                  {t('cta.readMore')}
                  <ArrowUpRight className="w-4 h-4" />
                </a>
              </div>
            </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BlogPosts;
